<div class="modal-header mfp-header">
    <h5 class="modal-title">{{ Task.TaskID ? 'Edit' : 'Create' }} Task</h5>
    <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"
    ></button>
</div>
<div class="modal-body">
    <div class="container-fluid">
        <div class="row my-2">
            <div class="col-12 col-md-6">Name:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Task.Name" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Company:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control" [(ngModel)]="Task.CompanyName" />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Assigned To:</div>
            <div class="col-12 col-md-6">
                <input type="text" class="form-control"
                       [(ngModel)]="Task.AssignedToEmployee"
                       [ngbTypeahead]="EmployeeSearch"
                       [inputFormatter]="FormatEmployee"
                       [resultFormatter]="FormatEmployee"
                       [editable]="false"
                />
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Task Type:</div>
            <div class="col-12 col-md-6">
                <select class="form-select" [(ngModel)]="Task.TaskType" [compareWith]="CompareTaskTypes">
                    <option *ngFor="let taskType of TaskTypeValues" [ngValue]="taskType">
                        {{ taskType.Name }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Task Status:</div>
            <div class="col-12 col-md-6">
                <select class="form-select" [(ngModel)]="Task.TaskStatus">
                    <option *ngFor="let status of TaskStatusValues" [ngValue]="status">
                        {{ TaskStatusDisplayValues[status] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Task Priority:</div>
            <div class="col-12 col-md-6">
                <div class="d-flex align-items-center gap-2">
                    <div class="indicator {{GetCurrentPriorityColor()}}"></div>
                    <select class="form-select" [(ngModel)]="Task.TaskPriority" [compareWith]="CompareTaskPriorities">
                        <option [ngValue]="null"></option>
                        <option *ngFor="let taskPriority of TaskPriorityValues" [ngValue]="taskPriority">
                            {{ taskPriority.Name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">Due Today:</div>
            <div class="col-12 col-md-6">
                <label>
                    <input name="due-today" type="checkbox" class="form-check-input mr-1" [(ngModel)]="Task.IsDueToday" />
                    Due Today
                </label>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12">Notes:</div>
            <div class="col-12">
                <textarea class="form-control"
                          [ngStyle]="{'min-height': GetNotesInputHeight()}"
                          [(ngModel)]="Task.Notes">
                </textarea>
            </div>
        </div>
        <div class="row my-2">
            <div class="col-12 col-md-6">File Attachments:</div>
            <div class="col-12 col-md-6" >
                <file-attachment-list
                        *ngIf="Task.TaskID; else CreateTaskToEnableFileAttachments"
                        [FileList]="Task.FileAttachments"
                        [EditMode]="true"
                        [UploadHandler]="FileUploader()"
                        [DeleteHandler]="FileDeleter()">
                </file-attachment-list>
                <ng-template #CreateTaskToEnableFileAttachments>
                    <button class="btn w-100 btn-warning" (click)="CreateTask()">Save to enable attachments</button>
                </ng-template>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="Cancel()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="Save()">Save</button>
</div>